import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ApplicationState } from '../../store';
import Layout from '../Layout/Layout';
import { actionCreators } from "../../store/LabEquipment";
import { Row } from 'reactstrap';
import "./utils/LabEquipment.css";
import labEquipmentDataPreparator from './utils/labEquipmentDataPreparator';
import EquipmentList from './EquipmentList';
import EquipmentRegistrationModal from './EquipmentRegistrationModal';

const NAT_TEST_GROUP_FILTER = "NAT";

const Virology = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actionCreators.fetchLabEquipment());
  }, [dispatch]);

  const viraQEquipment = useSelector((state: ApplicationState) =>
    state.labEquipment ? labEquipmentDataPreparator(state.labEquipment, NAT_TEST_GROUP_FILTER) : {}
  );

  const [modalOpen, setModalOpen] = useState(false);

  const openRegistrationModal = () => {
    setModalOpen(true);
  }

  return (
    <Layout>
      <Row className="cards-wrapper">
        <EquipmentList equipment={viraQEquipment} onSuccessfulStatusUpdate={() => {
          dispatch(actionCreators.fetchLabEquipment());
        }} />
      </Row>
      <Row>
        <input
          className="w-20 btn btn-primary btn-lg"
          value="Add equipment"
          onClick={openRegistrationModal}
        />
        {modalOpen && <EquipmentRegistrationModal testGroup={NAT_TEST_GROUP_FILTER} isOpen={modalOpen} toggle={() => setModalOpen(false)} onSuccessfulRegistration={() => {
          dispatch(actionCreators.fetchLabEquipment());
        }} />}
      </Row>
    </Layout>
  );
};

export default Virology;